import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { SourceControlState } from './SourceControl.type';
import { getSourceControlListThunk } from './SourceControl.thunk';

const SLICE_NAME = 'sourceControl';

const initialState: SourceControlState = {
  items: [],
  isLoading: false,
  pagination: undefined,
};

export const sourceControlSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setSourceControlList: (state, action) => ({
      ...state,
      items: action.payload,
    }),
  },
  extraReducers: builder => {
    builder.addCase(getSourceControlListThunk.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(
      getSourceControlListThunk.fulfilled,
      (state, { payload }) => {
        const { data, pagination } = payload;
        state.isLoading = false;
        state.items = data;
        state.pagination = {
          currentPage: pagination.current_page,
          lastPage: pagination.last_page,
          perPage: pagination.per_page,
          from: pagination.from,
          to: pagination.to,
          total: pagination.total,
        };
      },
    );
    builder.addCase(getSourceControlListThunk.rejected, state => {
      state.isLoading = false;
    });
  },
});

export const { setSourceControlList } = sourceControlSlice.actions;

export const getSourceControlListPagination = (state: RootState) =>
  state.sourceControl.pagination;

export const getSourceControlList = (state: RootState) =>
  state.sourceControl.items;

export default sourceControlSlice.reducer;
